import { FC, ReactNode, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useBreadcrumbs } from 'src/features/layout/hooks/useBreadcrumbs';

import { ProgramStepHeader } from '../components/ProgramStepHeader';
import { ConfigurationStep } from '../components/steps/ConfigurationStep/ConfigurationStep';
import { ContentStep } from '../components/steps/ContentStep/ContentStep';
import { InitialStep } from '../components/steps/InitialStep/InitialStep';
import { PublishStep } from '../components/steps/PublishStep/PublishStep';
import { VisualStep } from '../components/steps/VisualStep/VisualStep';
import { ProgramStepProvider } from '../contexts/ProgramStepContext';

export const CreateOrUpdateProgramsV2Screen: FC = () => {
  const params = useParams<{ id?: string }>();
  const programId = params.id ? Number(params.id) : undefined;

  useBreadcrumbs([
    {
      label: 'Trilhas',
      route: '/programs/v2',
    },
    {
      label: programId ? 'Editar Programa' : 'Criar Programa',
    },
  ]);

  const [step, setStep] = useState(0);

  const currentStep = useMemo(() => {
    const steps: Record<number, ReactNode> = {
      0: (
        <InitialStep
          programId={programId}
          changeStep={value => setStep(value)}
        />
      ),
      1: <ConfigurationStep programId={programId} />,
      2: <ContentStep programId={programId} />,
      3: <VisualStep programId={programId} />,
      4: <PublishStep programId={programId} />,
    };
    return steps[step] || null;
  }, [step, programId]);

  return (
    <ProgramStepProvider>
      <ProgramStepHeader
        programId={programId}
        currentStep={step}
        onChangeStep={setStep}
      />
      {currentStep}
    </ProgramStepProvider>
  );
};
